import { useQuery } from '@tanstack/react-query'

import MessageQueryKeyGenerator from './MessageQueryKeyGenerator'

import { getCompanyPageBatchResults } from '@/api/query'

interface UseCompanyPageBatchResultsParams {
  id: string
  quarter: number
  year: number
  is_latest?: boolean
  calendar_date?: string
  country?: string
  lang?: string
}

const useCompanyPageBatchResults = ({
  id,
  quarter,
  year,
  is_latest,
  calendar_date,
  country,
  lang,
}: UseCompanyPageBatchResultsParams) => {
  return useQuery({
    queryKey: [
      ...MessageQueryKeyGenerator.company_page_batch_results(id, quarter, year),
      is_latest,
      calendar_date,
      country,
      lang,
    ],
    queryFn: ({ signal }) =>
      getCompanyPageBatchResults(
        id,
        quarter,
        year,
        is_latest,
        calendar_date,
        country,
        lang,
        signal
      )(),
    refetchOnWindowFocus: false,
    enabled: !!id && !!quarter && !!year && quarter > 0 && year > 0,
    staleTime: 10 * 60 * 1000, // 10분
    cacheTime: 10 * 60 * 1000, // 10분
  })
}

export default useCompanyPageBatchResults
